import { Injectable } from '@angular/core';

@Injectable()
export class EmbeddedFrameService {
	isEmbedded: boolean;

	constructor() {
		this.isEmbedded = false;
	}

	setEmbeddedFrame(isEmbeddedFrame) {
		this.isEmbedded = isEmbeddedFrame;
	}

	isEmbeddedFrame() {
		return this.isEmbedded;
	}
}
